import React from 'react'
import CIcon from '@coreui/icons-react'
import {
  cilBell,
  cilCalculator,
  cilChartPie,
  cilCursor,
  cilDrop,
  cilNotes,
  cilPencil,
  cilPuzzle,
  cilUser,
  cilChart,
  cilSpeedometer,
  cilStar,
} from '@coreui/icons'
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react'

const _nav = [
  {
    component: CNavItem,
    name: 'Dashboard',
    to: '/dashboard',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'LeaderBoard',
    to: '/leaderboard',
    icon: <CIcon icon={cilChart} customClassName="nav-icon" />,
  },

  {
    component: CNavGroup,
    name: 'Player',
    to: '/base',
    icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Add Player',
        to: '/player-add',
      },
      {
        component: CNavItem,
        name: 'All Players',
        to: '/player-all',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Team',
    to: '/base',
    icon: <CIcon icon={cilPuzzle} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Add Team',
        to: '/team/add',
      },
      {
        component: CNavItem,
        name: 'All Teams',
        to: '/team/all',
      },
    ],
  },
]

export default _nav
